// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export * from '../exports';
export * from '/Users/lijixiang/Work/power-design/node_modules/.pnpm/dumi@2.4.21_@babel+core@7.28.0_@rspack+core@1.4.11_@swc+helpers@0.5.17__@swc+helpers@0._dc777004407fade72c157ed65013b588/node_modules/dumi/dist/client/theme-api/index.js';
export * from './meta/exports';
